import { TrashIcon, PencilIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { TagList } from "./TagList";
import { TagSelectModal } from "./TagSelectModal";
import { api } from "../../lib/api";

type Illustration = {
  id: string;
  title: string;
  file_name: string;
  storage_path: string;
  category: string;
  created_at: string;
  tag_ids: number[];
};

type Props = {
  illustration: Illustration;
  onDelete: (illustration: Illustration) => Promise<void>;
  onUpdate: () => void;
};

export const IllustrationCard = ({
  illustration,
  onDelete,
  onUpdate,
}: Props) => {
  const [isTagModalOpen, setIsTagModalOpen] = useState(false);

  const thumbUrl = api.getImageUrl(illustration.storage_path, { width: 240 });

  const handleImageClick = () => {
    const info = [
      `id: ${illustration.id}`,
      `title: ${illustration.title}`,
      `file_name: ${illustration.file_name}`,
      `storage_path: ${illustration.storage_path}`,
      `category: ${illustration.category}`,
      `created_at: ${illustration.created_at}`,
    ].join("\n");
    alert(`ファイル情報:\n${info}`);
  };

  return (
    <div className="border rounded-lg p-4">
      <div className="flex justify-between items-start mb-2">
        <div>
          <h4 className="font-bold">{illustration.title}</h4>
          <p className="text-sm text-gray-600">
            カテゴリー: {illustration.category}
          </p>
          <p className="text-sm text-gray-600">
            ファイル名: {illustration.file_name}
          </p>
        </div>
        <button
          onClick={() => onDelete(illustration)}
          className="text-gray-400 hover:text-red-600 transition-colors p-1"
          title="削除"
        >
          <TrashIcon className="w-4 h-4" />
        </button>
      </div>

      <div className="flex gap-4">
        <div className="w-24 h-24 flex-shrink-0">
          <img
            src={thumbUrl}
            alt={illustration.title}
            className="w-full h-full object-cover rounded cursor-pointer hover:opacity-80"
            onClick={handleImageClick}
          />
        </div>

        <div className="flex-grow flex flex-col justify-between">
          <div className="flex items-center gap-2 mb-2">
            <div className="flex-grow">
              {illustration.tag_ids && illustration.tag_ids.length > 0 && (
                <TagList
                  tagIds={illustration.tag_ids}
                  illustrationId={illustration.id}
                  onUpdate={onUpdate}
                />
              )}
            </div>
            <button
              onClick={() => setIsTagModalOpen(true)}
              className="p-1 hover:bg-gray-100 rounded flex-shrink-0"
              title="タグを編集"
            >
              <PencilIcon className="w-4 h-4 text-gray-500" />
            </button>
          </div>
        </div>
      </div>

      <TagSelectModal
        isOpen={isTagModalOpen}
        onClose={() => setIsTagModalOpen(false)}
        currentTagIds={illustration.tag_ids || []}
        illustrationId={illustration.id}
        onUpdate={onUpdate}
      />
    </div>
  );
};
